<div *ngIf="toastService.toastMessage$ | async as message" class="toast show manrope"
     [class.toast-progress]="toastService.inProgress$ | async">
  <span class="toast-spinner" *ngIf="toastService.inProgress$ | async"></span>
  <!-- ngFor over a single-item array with the text as its trackBy key: the span is
       recreated whenever the message changes, which replays the fade-in animation. -->
  <span class="toast-text" *ngFor="let line of [message]; trackBy: trackByText">{{ line }}</span>
</div>
